import AdminRoleFeatureMatrixPanel from "../components/access-control/AdminRoleFeatureMatrixPanel";

const AdminRoleFeatureMatrixPage = () => {
  return <AdminRoleFeatureMatrixPanel />;
};

export default AdminRoleFeatureMatrixPage;

